<template>
  <div id="DeviceMonitoring" class="w-100  min-vh-100" style="background-image:radial-gradient(circle at 50% 50%, #2f5278,#0f2239,#071729)">
   <div
      class="d-flex align-items-center justify-content-between"
      style="padding: 1rem 0px 0px; height: 4.5rem"
    >
      <div class="d-flex align-items-center">
        <img
          style="width:7.1875rem; height:100%"
          src="@/assets/images/dashboard/logo1.png"
          alt=""
        />
        <img
          style="width: 7.1875rem; height:100%"
          src="@/assets/images/dashboard/logo2.png"
          alt=""
        />
        <div style="color: #fff; font-size: 2rem; font-weight: 600">
          {{
            $t(
              "overview_static.nash_intelligent_iiot_after_market_management_system"
            )
          }}
        </div>
      </div>
      <div
        class="d-flex justify-content-around align-content-center align-items-center"
        style="width: 29rem; font-size: 0.9375rem; font-weight: 500"
      >
        <div class="d-flex align-content-center align-items-center" style="color:#ffffff">
          <div class="me-1 fs-18" style="font-weight: 400">{{ timeData }}</div>
          <div style="text-align: center">
            <div>{{ yearData }}</div>
            <div>{{ weekData }}</div>
          </div>
        </div>
        <div class="ms-1 header-item d-sm-flex cursor-pointer">
          <div
            class="language d-flex align-items-center flex-column justify-content-center"
            style="color: white; width: 42px"
          >
            <span
              :class="[
                'lang',
                language == 'ch' && 'current',
                language == 'ch' && 'fs-5',
              ]"
              @click="changeLang('ch')"
            >
              CN
            </span>
            <span
              :class="[
                'lang',
                language == 'en' && 'current',
                language == 'en' && 'fs-5',
              ]"
              @click="changeLang('en')"
            >
              EN
            </span>
          </div>
        </div>
        <div>
          <div>
            <i
              :class="[icon, 'me-3']"
              id="fullscreen"
              :style="{
                color: '#ffffff',
                cursor: 'pointer',
                fontSize: '32px',
              }"
              @click="toggleFullScreen()"
            ></i>
          </div>
        </div>
         <div class="dropdown">
            <button
              type="button"
              class="btn"
              id="page-header-user-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="d-flex align-items-center">
                <span class="text-start ms-xl-2">
                  <span
                    class="d-none d-xl-block ms-1 fs-12 text-white user-name-sub-text"
                    >{{ user.org.name || "" }}</span
                  >
                </span>
              </span>
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <b-link class="dropdown-item" href="###" @click="skipPage('repair-request/list')"
                ><i
                  class="mdi mdi-logout text-muted fs-16 align-middle me-1"
                ></i>
                <span class="align-middle" data-key="t-logout">主页</span>
              </b-link>
               <b-link class="dropdown-item" href="###" @click="logout"
                ><i
                  class="mdi mdi-logout text-muted fs-16 align-middle me-1"
                ></i>
                <span class="align-middle" data-key="t-logout">{{ $t('page.logout') }}</span>
              </b-link>
              <form
                id="frm_logout"
                method="post"
                action=""
                style="display: none"
              ></form>
            </div>
          </div>
      </div>
    </div>
    <iframe class="w-100" style=" height: calc(100% - 4.5rem); position: absolute"   :src="`http://52.83.189.182:18082/#/IV706E/?language=${$i18n.locale}`" frameborder="0"></iframe>
    
  </div>

</template>

<script>
import moment from "moment";
import { API_SVC_HOST } from "@/config/common";
import _ from "lodash";

export default {
  page: {
    title: "{{ $t('digital_twin') }}设备监控",
  },
  data() {
    return {
        timmer: null,
      timeData: "",
      yearData: "",
      weekData: "",
      fullscreen: false,
      pathType:'device_monitoring',
    };
  },
  methods:{
   skipPage(path) {
      console.log(path,"xxxxx");
      this.pathType = path;
      this.$router.push("/" + path);
    },
      moment,
        //全屏
    fullele() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        null
      );
    },

    //判断是否全屏
    isFullScreen() {
      return !!(document.webkitIsFullScreen || this.fullele());
    },
    //退出全屏
    exitFullscreen() {
      this.fullscreen = false;

      if (document.exitFullScreen) {
        document.exitFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    //全屏
    full(ele) {
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
    },
    //切换是否全屏 全屏按钮要执行的方法
    toggleFullScreen() {
      if (this.isFullScreen()) {
        this.exitFullscreen();
      } else {
        this.fullscreen = true;
        this.full(document.getElementById("DeviceMonitoring")); //要设置全屏的元素
      }
    },
    changeLang(lang) {
      this.language = lang;
      localStorage.setItem("language", lang);
      // 设置i18n.locale 组件库会按照上面的配置使用对应的文案文件
      // this.$i18n.locale = lang;
      window.location.reload();
    },
         logout() {
      var form = document.getElementById("frm_logout");
      form.action = this.logoutUrl;
      form.submit();
      sessionStorage.setItem("is_logout", "true")
      setTimeout(() => {
        localStorage.clear()
      }, 2000);
    },
  },
   computed: {
    icon() {
      return this.fullscreen ? "ri-fullscreen-exit-line" : "ri-fullscreen-line";
    },
       user() {
      return JSON.parse(localStorage.getItem('user'))
    },
      logoutUrl() {
      return _.trimEnd(_.trim(API_SVC_HOST, '"'), "/") + "/logout";
    },
  },
  mounted(){
        
    console.log("121212");
    let that = this;
    window.addEventListener("resize", () => {
        if (!that.isFullScreen()) {
          // 非全屏状态
          //业务逻辑
          this.fullscreen = false;
        }
    });

    this.language = localStorage.getItem("language") || "ch";
    this.timmer = setInterval(() => {
      this.timeData = this.moment().format("HH:mm:ss");
      this.yearData = this.moment().format("YYYY-M-D");
      this.weekData = [
        this.$t('overview_static.common["星期日"]'),
        this.$t('overview_static.common["星期一"]'),
        this.$t('overview_static.common["星期二"]'),
        this.$t('overview_static.common["星期三"]'),
        this.$t('overview_static.common["星期四"]'),
        this.$t('overview_static.common["星期五"]'),
        this.$t('overview_static.common["星期六"]'),
      ][this.moment().weekday()];
    }, 1000);
  },
    beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除定时器
    }
  },

 
};
</script>
<style lang="scss" scoped>
.clickActive {
  border-radius: 1.4623rem;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(255, 255, 255, 0.3) 100%
    ),
    rgba(111, 111, 111, 0.1);
  backdrop-filter: blur(5.3656rem);
}

</style>


